import React from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';
import FundInvestmentInvestor from '../../../models/admin/FundInvestmentData';
import StyledModal from '../../styles/StyledModal';

export interface InvestorInvestmentPromptModalProps {
  open: boolean;
  stage?: FundInvestmentInvestor['status'];
  investor?: FundInvestmentInvestor;
  amount?: string;
  error?: string;
  onClose: () => void;
  onAmountChange: (value: string) => void;
  onSubmit: () => void;
}

export default function InvestorInvestmentPromptModal({
  open,
  stage,
  investor,
  amount,
  error,
  onClose,
  onAmountChange,
  onSubmit,
}: InvestorInvestmentPromptModalProps) {
  const investmentPromptLabel =
    stage === 'OPPORTUNITY' ? 'Preferred Investment' : 'Committed Investment';

  return (
    <StyledModal
      open={open}
      onClose={onClose}
      title={`Promote to ${stage}`}
      actions={
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="contained" onClick={onSubmit}>
            Confirm
          </Button>
        </Box>
      }
    >
      <Typography variant="h6">{investmentPromptLabel}</Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        Enter the {investmentPromptLabel.toLowerCase()} amount for <strong>{investor?.name}</strong>
        :
      </Typography>

      <TextField
        type="number"
        label={investmentPromptLabel}
        variant="outlined"
        fullWidth
        value={amount}
        onChange={(e) => onAmountChange(e.target.value)}
        error={!!error}
        helperText={error}
        sx={{ mb: 2 }}
        InputProps={{
          startAdornment: <span style={{ marginRight: '8px' }}>$</span>,
        }}
      />
    </StyledModal>
  );
}
